import { atom } from 'recoil';
import { MoleculerListResult } from '../../@sprinx/knihovka-types';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { ShoppingCartProduct } from '../../api/shoppingCart';
import { ShoppingCustomerContact } from '../shopping';

export function getShippings(
  apiClient: ApiClient,
  customer: ShoppingCustomerContact,
  cartId: string,
): Promise<MoleculerListResult<any>> {
  return apiClient.post('/v1/shipping/list', { cartId, customer });
}

export const shippingsState = GlobalStateRegister.register(
  atom<Array<ShoppingCartProduct> | []>({
    key: 'shippings',
    default: [],
  }),
);
